/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutDisabledRouteImport } from './routes/logout-disabled'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedKycRouteImport } from './routes/_authenticated/kyc'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedSidebarRouteRouteImport } from './routes/_authenticated/_sidebar/route'
import { Route as AuthenticatedSidebarTradeRouteImport } from './routes/_authenticated/_sidebar/trade'
import { Route as AuthenticatedSidebarProjectsRouteImport } from './routes/_authenticated/_sidebar/projects'
import { Route as AuthenticatedSidebarProjectRouteImport } from './routes/_authenticated/_sidebar/project'
import { Route as AuthenticatedSidebarDashboardRouteImport } from './routes/_authenticated/_sidebar/dashboard'
import { Route as AuthenticatedSidebarSettingsRouteRouteImport } from './routes/_authenticated/_sidebar/settings/route'
import { Route as AuthenticatedSidebarObserverRouteRouteImport } from './routes/_authenticated/_sidebar/observer/route'
import { Route as AuthenticatedSidebarInvestorRouteRouteImport } from './routes/_authenticated/_sidebar/investor/route'
import { Route as AuthenticatedSidebarGrowerRouteRouteImport } from './routes/_authenticated/_sidebar/grower/route'
import { Route as AuthenticatedSidebarSettingsIndexRouteImport } from './routes/_authenticated/_sidebar/settings/index'
import { Route as AuthenticatedSidebarSettingsNotificationsRouteImport } from './routes/_authenticated/_sidebar/settings/notifications'
import { Route as AuthenticatedSidebarSettingsDisplayRouteImport } from './routes/_authenticated/_sidebar/settings/display'
import { Route as AuthenticatedSidebarSettingsAppearanceRouteImport } from './routes/_authenticated/_sidebar/settings/appearance'
import { Route as AuthenticatedSidebarSettingsAccountRouteImport } from './routes/_authenticated/_sidebar/settings/account'
import { Route as AuthenticatedSidebarProjectIdRouteImport } from './routes/_authenticated/_sidebar/project.$id'
import { Route as AuthenticatedSidebarObserverCertificationRequestsRouteImport } from './routes/_authenticated/_sidebar/observer/certification-requests'
import { Route as AuthenticatedSidebarObserverCertificationHistoryRouteImport } from './routes/_authenticated/_sidebar/observer/certification-history'
import { Route as AuthenticatedSidebarInvestorNftsRouteImport } from './routes/_authenticated/_sidebar/investor/nfts'
import { Route as AuthenticatedSidebarInvestorMyAssetsRouteImport } from './routes/_authenticated/_sidebar/investor/my-assets'
import { Route as AuthenticatedSidebarGrowerMyProjectsRouteImport } from './routes/_authenticated/_sidebar/grower/my-projects'
import { Route as AuthenticatedSidebarGrowerDraftsRouteImport } from './routes/_authenticated/_sidebar/grower/drafts'
import { Route as AuthenticatedSidebarObserverRequestsRequestIdRouteImport } from './routes/_authenticated/_sidebar/observer/requests/$requestId'
import { Route as AuthenticatedSidebarGrowerProjectsProjectIdIndexRouteImport } from './routes/_authenticated/_sidebar/grower/projects/$projectId/index'
import { Route as AuthenticatedSidebarGrowerProjectsProjectIdEditRouteImport } from './routes/_authenticated/_sidebar/grower/projects/$projectId/edit'

const LogoutDisabledRoute = LogoutDisabledRouteImport.update({
  id: '/logout-disabled',
  path: '/logout-disabled',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedKycRoute = AuthenticatedKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSidebarRouteRoute =
  AuthenticatedSidebarRouteRouteImport.update({
    id: '/_sidebar',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSidebarTradeRoute =
  AuthenticatedSidebarTradeRouteImport.update({
    id: '/trade',
    path: '/trade',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarProjectsRoute =
  AuthenticatedSidebarProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarProjectRoute =
  AuthenticatedSidebarProjectRouteImport.update({
    id: '/project',
    path: '/project',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarDashboardRoute =
  AuthenticatedSidebarDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarSettingsRouteRoute =
  AuthenticatedSidebarSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarObserverRouteRoute =
  AuthenticatedSidebarObserverRouteRouteImport.update({
    id: '/observer',
    path: '/observer',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarInvestorRouteRoute =
  AuthenticatedSidebarInvestorRouteRouteImport.update({
    id: '/investor',
    path: '/investor',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarGrowerRouteRoute =
  AuthenticatedSidebarGrowerRouteRouteImport.update({
    id: '/grower',
    path: '/grower',
    getParentRoute: () => AuthenticatedSidebarRouteRoute,
  } as any)
const AuthenticatedSidebarSettingsIndexRoute =
  AuthenticatedSidebarSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSidebarSettingsRouteRoute,
  } as any)
const AuthenticatedSidebarSettingsNotificationsRoute =
  AuthenticatedSidebarSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSidebarSettingsRouteRoute,
  } as any)
const AuthenticatedSidebarSettingsDisplayRoute =
  AuthenticatedSidebarSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSidebarSettingsRouteRoute,
  } as any)
const AuthenticatedSidebarSettingsAppearanceRoute =
  AuthenticatedSidebarSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSidebarSettingsRouteRoute,
  } as any)
const AuthenticatedSidebarSettingsAccountRoute =
  AuthenticatedSidebarSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSidebarSettingsRouteRoute,
  } as any)
const AuthenticatedSidebarProjectIdRoute =
  AuthenticatedSidebarProjectIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSidebarProjectRoute,
  } as any)
const AuthenticatedSidebarObserverCertificationRequestsRoute =
  AuthenticatedSidebarObserverCertificationRequestsRouteImport.update({
    id: '/certification-requests',
    path: '/certification-requests',
    getParentRoute: () => AuthenticatedSidebarObserverRouteRoute,
  } as any)
const AuthenticatedSidebarObserverCertificationHistoryRoute =
  AuthenticatedSidebarObserverCertificationHistoryRouteImport.update({
    id: '/certification-history',
    path: '/certification-history',
    getParentRoute: () => AuthenticatedSidebarObserverRouteRoute,
  } as any)
const AuthenticatedSidebarInvestorNftsRoute =
  AuthenticatedSidebarInvestorNftsRouteImport.update({
    id: '/nfts',
    path: '/nfts',
    getParentRoute: () => AuthenticatedSidebarInvestorRouteRoute,
  } as any)
const AuthenticatedSidebarInvestorMyAssetsRoute =
  AuthenticatedSidebarInvestorMyAssetsRouteImport.update({
    id: '/my-assets',
    path: '/my-assets',
    getParentRoute: () => AuthenticatedSidebarInvestorRouteRoute,
  } as any)
const AuthenticatedSidebarGrowerMyProjectsRoute =
  AuthenticatedSidebarGrowerMyProjectsRouteImport.update({
    id: '/my-projects',
    path: '/my-projects',
    getParentRoute: () => AuthenticatedSidebarGrowerRouteRoute,
  } as any)
const AuthenticatedSidebarGrowerDraftsRoute =
  AuthenticatedSidebarGrowerDraftsRouteImport.update({
    id: '/drafts',
    path: '/drafts',
    getParentRoute: () => AuthenticatedSidebarGrowerRouteRoute,
  } as any)
const AuthenticatedSidebarObserverRequestsRequestIdRoute =
  AuthenticatedSidebarObserverRequestsRequestIdRouteImport.update({
    id: '/requests/$requestId',
    path: '/requests/$requestId',
    getParentRoute: () => AuthenticatedSidebarObserverRouteRoute,
  } as any)
const AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute =
  AuthenticatedSidebarGrowerProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AuthenticatedSidebarGrowerRouteRoute,
  } as any)
const AuthenticatedSidebarGrowerProjectsProjectIdEditRoute =
  AuthenticatedSidebarGrowerProjectsProjectIdEditRouteImport.update({
    id: '/projects/$projectId/edit',
    path: '/projects/$projectId/edit',
    getParentRoute: () => AuthenticatedSidebarGrowerRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/logout-disabled': typeof LogoutDisabledRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/kyc': typeof AuthenticatedKycRoute
  '/grower': typeof AuthenticatedSidebarGrowerRouteRouteWithChildren
  '/investor': typeof AuthenticatedSidebarInvestorRouteRouteWithChildren
  '/observer': typeof AuthenticatedSidebarObserverRouteRouteWithChildren
  '/settings': typeof AuthenticatedSidebarSettingsRouteRouteWithChildren
  '/dashboard': typeof AuthenticatedSidebarDashboardRoute
  '/project': typeof AuthenticatedSidebarProjectRouteWithChildren
  '/projects': typeof AuthenticatedSidebarProjectsRoute
  '/trade': typeof AuthenticatedSidebarTradeRoute
  '/grower/drafts': typeof AuthenticatedSidebarGrowerDraftsRoute
  '/grower/my-projects': typeof AuthenticatedSidebarGrowerMyProjectsRoute
  '/investor/my-assets': typeof AuthenticatedSidebarInvestorMyAssetsRoute
  '/investor/nfts': typeof AuthenticatedSidebarInvestorNftsRoute
  '/observer/certification-history': typeof AuthenticatedSidebarObserverCertificationHistoryRoute
  '/observer/certification-requests': typeof AuthenticatedSidebarObserverCertificationRequestsRoute
  '/project/$id': typeof AuthenticatedSidebarProjectIdRoute
  '/settings/account': typeof AuthenticatedSidebarSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSidebarSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSidebarSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSidebarSettingsNotificationsRoute
  '/settings/': typeof AuthenticatedSidebarSettingsIndexRoute
  '/observer/requests/$requestId': typeof AuthenticatedSidebarObserverRequestsRequestIdRoute
  '/grower/projects/$projectId/edit': typeof AuthenticatedSidebarGrowerProjectsProjectIdEditRoute
  '/grower/projects/$projectId': typeof AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/logout-disabled': typeof LogoutDisabledRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/kyc': typeof AuthenticatedKycRoute
  '/grower': typeof AuthenticatedSidebarGrowerRouteRouteWithChildren
  '/investor': typeof AuthenticatedSidebarInvestorRouteRouteWithChildren
  '/observer': typeof AuthenticatedSidebarObserverRouteRouteWithChildren
  '/dashboard': typeof AuthenticatedSidebarDashboardRoute
  '/project': typeof AuthenticatedSidebarProjectRouteWithChildren
  '/projects': typeof AuthenticatedSidebarProjectsRoute
  '/trade': typeof AuthenticatedSidebarTradeRoute
  '/grower/drafts': typeof AuthenticatedSidebarGrowerDraftsRoute
  '/grower/my-projects': typeof AuthenticatedSidebarGrowerMyProjectsRoute
  '/investor/my-assets': typeof AuthenticatedSidebarInvestorMyAssetsRoute
  '/investor/nfts': typeof AuthenticatedSidebarInvestorNftsRoute
  '/observer/certification-history': typeof AuthenticatedSidebarObserverCertificationHistoryRoute
  '/observer/certification-requests': typeof AuthenticatedSidebarObserverCertificationRequestsRoute
  '/project/$id': typeof AuthenticatedSidebarProjectIdRoute
  '/settings/account': typeof AuthenticatedSidebarSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSidebarSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSidebarSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSidebarSettingsNotificationsRoute
  '/settings': typeof AuthenticatedSidebarSettingsIndexRoute
  '/observer/requests/$requestId': typeof AuthenticatedSidebarObserverRequestsRequestIdRoute
  '/grower/projects/$projectId/edit': typeof AuthenticatedSidebarGrowerProjectsProjectIdEditRoute
  '/grower/projects/$projectId': typeof AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/logout-disabled': typeof LogoutDisabledRoute
  '/_authenticated/_sidebar': typeof AuthenticatedSidebarRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/kyc': typeof AuthenticatedKycRoute
  '/_authenticated/_sidebar/grower': typeof AuthenticatedSidebarGrowerRouteRouteWithChildren
  '/_authenticated/_sidebar/investor': typeof AuthenticatedSidebarInvestorRouteRouteWithChildren
  '/_authenticated/_sidebar/observer': typeof AuthenticatedSidebarObserverRouteRouteWithChildren
  '/_authenticated/_sidebar/settings': typeof AuthenticatedSidebarSettingsRouteRouteWithChildren
  '/_authenticated/_sidebar/dashboard': typeof AuthenticatedSidebarDashboardRoute
  '/_authenticated/_sidebar/project': typeof AuthenticatedSidebarProjectRouteWithChildren
  '/_authenticated/_sidebar/projects': typeof AuthenticatedSidebarProjectsRoute
  '/_authenticated/_sidebar/trade': typeof AuthenticatedSidebarTradeRoute
  '/_authenticated/_sidebar/grower/drafts': typeof AuthenticatedSidebarGrowerDraftsRoute
  '/_authenticated/_sidebar/grower/my-projects': typeof AuthenticatedSidebarGrowerMyProjectsRoute
  '/_authenticated/_sidebar/investor/my-assets': typeof AuthenticatedSidebarInvestorMyAssetsRoute
  '/_authenticated/_sidebar/investor/nfts': typeof AuthenticatedSidebarInvestorNftsRoute
  '/_authenticated/_sidebar/observer/certification-history': typeof AuthenticatedSidebarObserverCertificationHistoryRoute
  '/_authenticated/_sidebar/observer/certification-requests': typeof AuthenticatedSidebarObserverCertificationRequestsRoute
  '/_authenticated/_sidebar/project/$id': typeof AuthenticatedSidebarProjectIdRoute
  '/_authenticated/_sidebar/settings/account': typeof AuthenticatedSidebarSettingsAccountRoute
  '/_authenticated/_sidebar/settings/appearance': typeof AuthenticatedSidebarSettingsAppearanceRoute
  '/_authenticated/_sidebar/settings/display': typeof AuthenticatedSidebarSettingsDisplayRoute
  '/_authenticated/_sidebar/settings/notifications': typeof AuthenticatedSidebarSettingsNotificationsRoute
  '/_authenticated/_sidebar/settings/': typeof AuthenticatedSidebarSettingsIndexRoute
  '/_authenticated/_sidebar/observer/requests/$requestId': typeof AuthenticatedSidebarObserverRequestsRequestIdRoute
  '/_authenticated/_sidebar/grower/projects/$projectId/edit': typeof AuthenticatedSidebarGrowerProjectsProjectIdEditRoute
  '/_authenticated/_sidebar/grower/projects/$projectId/': typeof AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/logout-disabled'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/kyc'
    | '/grower'
    | '/investor'
    | '/observer'
    | '/settings'
    | '/dashboard'
    | '/project'
    | '/projects'
    | '/trade'
    | '/grower/drafts'
    | '/grower/my-projects'
    | '/investor/my-assets'
    | '/investor/nfts'
    | '/observer/certification-history'
    | '/observer/certification-requests'
    | '/project/$id'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/'
    | '/observer/requests/$requestId'
    | '/grower/projects/$projectId/edit'
    | '/grower/projects/$projectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logout-disabled'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/kyc'
    | '/grower'
    | '/investor'
    | '/observer'
    | '/dashboard'
    | '/project'
    | '/projects'
    | '/trade'
    | '/grower/drafts'
    | '/grower/my-projects'
    | '/investor/my-assets'
    | '/investor/nfts'
    | '/observer/certification-history'
    | '/observer/certification-requests'
    | '/project/$id'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings'
    | '/observer/requests/$requestId'
    | '/grower/projects/$projectId/edit'
    | '/grower/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/logout-disabled'
    | '/_authenticated/_sidebar'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/kyc'
    | '/_authenticated/_sidebar/grower'
    | '/_authenticated/_sidebar/investor'
    | '/_authenticated/_sidebar/observer'
    | '/_authenticated/_sidebar/settings'
    | '/_authenticated/_sidebar/dashboard'
    | '/_authenticated/_sidebar/project'
    | '/_authenticated/_sidebar/projects'
    | '/_authenticated/_sidebar/trade'
    | '/_authenticated/_sidebar/grower/drafts'
    | '/_authenticated/_sidebar/grower/my-projects'
    | '/_authenticated/_sidebar/investor/my-assets'
    | '/_authenticated/_sidebar/investor/nfts'
    | '/_authenticated/_sidebar/observer/certification-history'
    | '/_authenticated/_sidebar/observer/certification-requests'
    | '/_authenticated/_sidebar/project/$id'
    | '/_authenticated/_sidebar/settings/account'
    | '/_authenticated/_sidebar/settings/appearance'
    | '/_authenticated/_sidebar/settings/display'
    | '/_authenticated/_sidebar/settings/notifications'
    | '/_authenticated/_sidebar/settings/'
    | '/_authenticated/_sidebar/observer/requests/$requestId'
    | '/_authenticated/_sidebar/grower/projects/$projectId/edit'
    | '/_authenticated/_sidebar/grower/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LogoutDisabledRoute: typeof LogoutDisabledRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout-disabled': {
      id: '/logout-disabled'
      path: '/logout-disabled'
      fullPath: '/logout-disabled'
      preLoaderRoute: typeof LogoutDisabledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/kyc': {
      id: '/_authenticated/kyc'
      path: '/kyc'
      fullPath: '/kyc'
      preLoaderRoute: typeof AuthenticatedKycRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_sidebar': {
      id: '/_authenticated/_sidebar'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_sidebar/trade': {
      id: '/_authenticated/_sidebar/trade'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof AuthenticatedSidebarTradeRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/projects': {
      id: '/_authenticated/_sidebar/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedSidebarProjectsRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/project': {
      id: '/_authenticated/_sidebar/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof AuthenticatedSidebarProjectRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/dashboard': {
      id: '/_authenticated/_sidebar/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedSidebarDashboardRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/settings': {
      id: '/_authenticated/_sidebar/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSidebarSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/observer': {
      id: '/_authenticated/_sidebar/observer'
      path: '/observer'
      fullPath: '/observer'
      preLoaderRoute: typeof AuthenticatedSidebarObserverRouteRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/investor': {
      id: '/_authenticated/_sidebar/investor'
      path: '/investor'
      fullPath: '/investor'
      preLoaderRoute: typeof AuthenticatedSidebarInvestorRouteRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/grower': {
      id: '/_authenticated/_sidebar/grower'
      path: '/grower'
      fullPath: '/grower'
      preLoaderRoute: typeof AuthenticatedSidebarGrowerRouteRouteImport
      parentRoute: typeof AuthenticatedSidebarRouteRoute
    }
    '/_authenticated/_sidebar/settings/': {
      id: '/_authenticated/_sidebar/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSidebarSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarSettingsRouteRoute
    }
    '/_authenticated/_sidebar/settings/notifications': {
      id: '/_authenticated/_sidebar/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSidebarSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSidebarSettingsRouteRoute
    }
    '/_authenticated/_sidebar/settings/display': {
      id: '/_authenticated/_sidebar/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSidebarSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSidebarSettingsRouteRoute
    }
    '/_authenticated/_sidebar/settings/appearance': {
      id: '/_authenticated/_sidebar/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSidebarSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSidebarSettingsRouteRoute
    }
    '/_authenticated/_sidebar/settings/account': {
      id: '/_authenticated/_sidebar/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSidebarSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSidebarSettingsRouteRoute
    }
    '/_authenticated/_sidebar/project/$id': {
      id: '/_authenticated/_sidebar/project/$id'
      path: '/$id'
      fullPath: '/project/$id'
      preLoaderRoute: typeof AuthenticatedSidebarProjectIdRouteImport
      parentRoute: typeof AuthenticatedSidebarProjectRoute
    }
    '/_authenticated/_sidebar/observer/certification-requests': {
      id: '/_authenticated/_sidebar/observer/certification-requests'
      path: '/certification-requests'
      fullPath: '/observer/certification-requests'
      preLoaderRoute: typeof AuthenticatedSidebarObserverCertificationRequestsRouteImport
      parentRoute: typeof AuthenticatedSidebarObserverRouteRoute
    }
    '/_authenticated/_sidebar/observer/certification-history': {
      id: '/_authenticated/_sidebar/observer/certification-history'
      path: '/certification-history'
      fullPath: '/observer/certification-history'
      preLoaderRoute: typeof AuthenticatedSidebarObserverCertificationHistoryRouteImport
      parentRoute: typeof AuthenticatedSidebarObserverRouteRoute
    }
    '/_authenticated/_sidebar/investor/nfts': {
      id: '/_authenticated/_sidebar/investor/nfts'
      path: '/nfts'
      fullPath: '/investor/nfts'
      preLoaderRoute: typeof AuthenticatedSidebarInvestorNftsRouteImport
      parentRoute: typeof AuthenticatedSidebarInvestorRouteRoute
    }
    '/_authenticated/_sidebar/investor/my-assets': {
      id: '/_authenticated/_sidebar/investor/my-assets'
      path: '/my-assets'
      fullPath: '/investor/my-assets'
      preLoaderRoute: typeof AuthenticatedSidebarInvestorMyAssetsRouteImport
      parentRoute: typeof AuthenticatedSidebarInvestorRouteRoute
    }
    '/_authenticated/_sidebar/grower/my-projects': {
      id: '/_authenticated/_sidebar/grower/my-projects'
      path: '/my-projects'
      fullPath: '/grower/my-projects'
      preLoaderRoute: typeof AuthenticatedSidebarGrowerMyProjectsRouteImport
      parentRoute: typeof AuthenticatedSidebarGrowerRouteRoute
    }
    '/_authenticated/_sidebar/grower/drafts': {
      id: '/_authenticated/_sidebar/grower/drafts'
      path: '/drafts'
      fullPath: '/grower/drafts'
      preLoaderRoute: typeof AuthenticatedSidebarGrowerDraftsRouteImport
      parentRoute: typeof AuthenticatedSidebarGrowerRouteRoute
    }
    '/_authenticated/_sidebar/observer/requests/$requestId': {
      id: '/_authenticated/_sidebar/observer/requests/$requestId'
      path: '/requests/$requestId'
      fullPath: '/observer/requests/$requestId'
      preLoaderRoute: typeof AuthenticatedSidebarObserverRequestsRequestIdRouteImport
      parentRoute: typeof AuthenticatedSidebarObserverRouteRoute
    }
    '/_authenticated/_sidebar/grower/projects/$projectId/': {
      id: '/_authenticated/_sidebar/grower/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/grower/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedSidebarGrowerProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarGrowerRouteRoute
    }
    '/_authenticated/_sidebar/grower/projects/$projectId/edit': {
      id: '/_authenticated/_sidebar/grower/projects/$projectId/edit'
      path: '/projects/$projectId/edit'
      fullPath: '/grower/projects/$projectId/edit'
      preLoaderRoute: typeof AuthenticatedSidebarGrowerProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthenticatedSidebarGrowerRouteRoute
    }
  }
}

interface AuthenticatedSidebarGrowerRouteRouteChildren {
  AuthenticatedSidebarGrowerDraftsRoute: typeof AuthenticatedSidebarGrowerDraftsRoute
  AuthenticatedSidebarGrowerMyProjectsRoute: typeof AuthenticatedSidebarGrowerMyProjectsRoute
  AuthenticatedSidebarGrowerProjectsProjectIdEditRoute: typeof AuthenticatedSidebarGrowerProjectsProjectIdEditRoute
  AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute: typeof AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute
}

const AuthenticatedSidebarGrowerRouteRouteChildren: AuthenticatedSidebarGrowerRouteRouteChildren =
  {
    AuthenticatedSidebarGrowerDraftsRoute:
      AuthenticatedSidebarGrowerDraftsRoute,
    AuthenticatedSidebarGrowerMyProjectsRoute:
      AuthenticatedSidebarGrowerMyProjectsRoute,
    AuthenticatedSidebarGrowerProjectsProjectIdEditRoute:
      AuthenticatedSidebarGrowerProjectsProjectIdEditRoute,
    AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute:
      AuthenticatedSidebarGrowerProjectsProjectIdIndexRoute,
  }

const AuthenticatedSidebarGrowerRouteRouteWithChildren =
  AuthenticatedSidebarGrowerRouteRoute._addFileChildren(
    AuthenticatedSidebarGrowerRouteRouteChildren,
  )

interface AuthenticatedSidebarInvestorRouteRouteChildren {
  AuthenticatedSidebarInvestorMyAssetsRoute: typeof AuthenticatedSidebarInvestorMyAssetsRoute
  AuthenticatedSidebarInvestorNftsRoute: typeof AuthenticatedSidebarInvestorNftsRoute
}

const AuthenticatedSidebarInvestorRouteRouteChildren: AuthenticatedSidebarInvestorRouteRouteChildren =
  {
    AuthenticatedSidebarInvestorMyAssetsRoute:
      AuthenticatedSidebarInvestorMyAssetsRoute,
    AuthenticatedSidebarInvestorNftsRoute:
      AuthenticatedSidebarInvestorNftsRoute,
  }

const AuthenticatedSidebarInvestorRouteRouteWithChildren =
  AuthenticatedSidebarInvestorRouteRoute._addFileChildren(
    AuthenticatedSidebarInvestorRouteRouteChildren,
  )

interface AuthenticatedSidebarObserverRouteRouteChildren {
  AuthenticatedSidebarObserverCertificationHistoryRoute: typeof AuthenticatedSidebarObserverCertificationHistoryRoute
  AuthenticatedSidebarObserverCertificationRequestsRoute: typeof AuthenticatedSidebarObserverCertificationRequestsRoute
  AuthenticatedSidebarObserverRequestsRequestIdRoute: typeof AuthenticatedSidebarObserverRequestsRequestIdRoute
}

const AuthenticatedSidebarObserverRouteRouteChildren: AuthenticatedSidebarObserverRouteRouteChildren =
  {
    AuthenticatedSidebarObserverCertificationHistoryRoute:
      AuthenticatedSidebarObserverCertificationHistoryRoute,
    AuthenticatedSidebarObserverCertificationRequestsRoute:
      AuthenticatedSidebarObserverCertificationRequestsRoute,
    AuthenticatedSidebarObserverRequestsRequestIdRoute:
      AuthenticatedSidebarObserverRequestsRequestIdRoute,
  }

const AuthenticatedSidebarObserverRouteRouteWithChildren =
  AuthenticatedSidebarObserverRouteRoute._addFileChildren(
    AuthenticatedSidebarObserverRouteRouteChildren,
  )

interface AuthenticatedSidebarSettingsRouteRouteChildren {
  AuthenticatedSidebarSettingsAccountRoute: typeof AuthenticatedSidebarSettingsAccountRoute
  AuthenticatedSidebarSettingsAppearanceRoute: typeof AuthenticatedSidebarSettingsAppearanceRoute
  AuthenticatedSidebarSettingsDisplayRoute: typeof AuthenticatedSidebarSettingsDisplayRoute
  AuthenticatedSidebarSettingsNotificationsRoute: typeof AuthenticatedSidebarSettingsNotificationsRoute
  AuthenticatedSidebarSettingsIndexRoute: typeof AuthenticatedSidebarSettingsIndexRoute
}

const AuthenticatedSidebarSettingsRouteRouteChildren: AuthenticatedSidebarSettingsRouteRouteChildren =
  {
    AuthenticatedSidebarSettingsAccountRoute:
      AuthenticatedSidebarSettingsAccountRoute,
    AuthenticatedSidebarSettingsAppearanceRoute:
      AuthenticatedSidebarSettingsAppearanceRoute,
    AuthenticatedSidebarSettingsDisplayRoute:
      AuthenticatedSidebarSettingsDisplayRoute,
    AuthenticatedSidebarSettingsNotificationsRoute:
      AuthenticatedSidebarSettingsNotificationsRoute,
    AuthenticatedSidebarSettingsIndexRoute:
      AuthenticatedSidebarSettingsIndexRoute,
  }

const AuthenticatedSidebarSettingsRouteRouteWithChildren =
  AuthenticatedSidebarSettingsRouteRoute._addFileChildren(
    AuthenticatedSidebarSettingsRouteRouteChildren,
  )

interface AuthenticatedSidebarProjectRouteChildren {
  AuthenticatedSidebarProjectIdRoute: typeof AuthenticatedSidebarProjectIdRoute
}

const AuthenticatedSidebarProjectRouteChildren: AuthenticatedSidebarProjectRouteChildren =
  {
    AuthenticatedSidebarProjectIdRoute: AuthenticatedSidebarProjectIdRoute,
  }

const AuthenticatedSidebarProjectRouteWithChildren =
  AuthenticatedSidebarProjectRoute._addFileChildren(
    AuthenticatedSidebarProjectRouteChildren,
  )

interface AuthenticatedSidebarRouteRouteChildren {
  AuthenticatedSidebarGrowerRouteRoute: typeof AuthenticatedSidebarGrowerRouteRouteWithChildren
  AuthenticatedSidebarInvestorRouteRoute: typeof AuthenticatedSidebarInvestorRouteRouteWithChildren
  AuthenticatedSidebarObserverRouteRoute: typeof AuthenticatedSidebarObserverRouteRouteWithChildren
  AuthenticatedSidebarSettingsRouteRoute: typeof AuthenticatedSidebarSettingsRouteRouteWithChildren
  AuthenticatedSidebarDashboardRoute: typeof AuthenticatedSidebarDashboardRoute
  AuthenticatedSidebarProjectRoute: typeof AuthenticatedSidebarProjectRouteWithChildren
  AuthenticatedSidebarProjectsRoute: typeof AuthenticatedSidebarProjectsRoute
  AuthenticatedSidebarTradeRoute: typeof AuthenticatedSidebarTradeRoute
}

const AuthenticatedSidebarRouteRouteChildren: AuthenticatedSidebarRouteRouteChildren =
  {
    AuthenticatedSidebarGrowerRouteRoute:
      AuthenticatedSidebarGrowerRouteRouteWithChildren,
    AuthenticatedSidebarInvestorRouteRoute:
      AuthenticatedSidebarInvestorRouteRouteWithChildren,
    AuthenticatedSidebarObserverRouteRoute:
      AuthenticatedSidebarObserverRouteRouteWithChildren,
    AuthenticatedSidebarSettingsRouteRoute:
      AuthenticatedSidebarSettingsRouteRouteWithChildren,
    AuthenticatedSidebarDashboardRoute: AuthenticatedSidebarDashboardRoute,
    AuthenticatedSidebarProjectRoute:
      AuthenticatedSidebarProjectRouteWithChildren,
    AuthenticatedSidebarProjectsRoute: AuthenticatedSidebarProjectsRoute,
    AuthenticatedSidebarTradeRoute: AuthenticatedSidebarTradeRoute,
  }

const AuthenticatedSidebarRouteRouteWithChildren =
  AuthenticatedSidebarRouteRoute._addFileChildren(
    AuthenticatedSidebarRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSidebarRouteRoute: typeof AuthenticatedSidebarRouteRouteWithChildren
  AuthenticatedKycRoute: typeof AuthenticatedKycRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSidebarRouteRoute: AuthenticatedSidebarRouteRouteWithChildren,
  AuthenticatedKycRoute: AuthenticatedKycRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LogoutDisabledRoute: LogoutDisabledRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
